import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { RouteAnimation } from 'src/animations/animations';
import { Divider } from 'src/components/shared/Divider/Divider';
import { useReduxDispatch } from 'src/store';
import {
  MixtureTypeDetailDto,
  MixtureTypeParameterDto
} from 'src/store/mixturetypes/mixturetype';
import { mapMixtureTypeDetailToEdit } from 'src/store/mixturetypes/mixturetype.map';
import {
  createMixtureType,
  editMixtureType,
  MixtureTypeTypes
} from 'src/store/mixturetypes/mixturetypes.actions';
import { MixtureTypeApi } from 'src/store/mixturetypes/mixturetypes.api';
import { push } from 'src/utils/navigation';
import { MixtureTypeDetailsForm } from './MixtureTypeDetailsForm';
import { StandardPractice } from './StandardPractice';

export const MixtureTypePage = () => {
  const dispatch = useReduxDispatch();
  const { id: idParam } = useParams();
  const navigate = useNavigate();

  const [mixtureTypeParameters, setMixtureTypeParameters] = useState<
    MixtureTypeParameterDto[]
  >([]);

  const [mixtureType, setMixtureType] =
    useState<Nullable<MixtureTypeDetailDto>>(null);

  useEffect(() => {
    const fetch = async () => {
      const response = await MixtureTypeApi.getById(Number(idParam));
      if (response.ok) {
        setMixtureType(response.data);
      }
    };

    if (!!idParam) {
      fetch();
    }
  }, [idParam, dispatch]);

  const onCancel = () => {
    push('/mixturetypes', navigate, RouteAnimation.SlideLeft);
  };

  const onSubmit = async (mixtureType: MixtureTypeDetailDto) => {
    const dto = mapMixtureTypeDetailToEdit(mixtureType);
    dto.mixtureTypeParameters = mixtureTypeParameters;
    const result = dto.id
      ? await dispatch(editMixtureType(dto.id, dto))
      : await dispatch(createMixtureType(dto));
    if (result.type !== MixtureTypeTypes.Failure) {
      onCancel();
    }
  };

  return (
    <React.Fragment>
      <MixtureTypeDetailsForm
        mixtureType={mixtureType}
        onCancel={onCancel}
        onSubmit={onSubmit}
      />
      <Divider />
      <StandardPractice
        mixtureType={mixtureType}
        onParametersChanged={parameters => {
          setMixtureTypeParameters(parameters);
        }}
      />
    </React.Fragment>
  );
};
